import windAvatar from './assets/wind.jpg'
import sierraAvatar from './assets/sierra.jpg'
import mediaAvatar from './assets/media.jpg'
import chessAvatar from './assets/chess.jpg'
import artAvatar from './assets/art.jpg'
import { WindIcon, SierraIcon, FilmIcon, ChessIcon, ArtIcon } from './icons'

/**
 * The Dionyziuz suite: the apps we build and support.
 * The four Telegram agents live on Telegram; the art studio lives in-app.
 * Each agent uses its official Telegram profile avatar depicted in a circle.
 */
export const APPS = [
  {
    id: 'wind',
    name: 'Windsports',
    avatar: windAvatar,
    icon: WindIcon,
    badge: 'Telegram Agent',
    tagline: 'Wind intelligence for the water',
    description:
      'Built specifically for wingfoilers, kiters, and windsurfers. Real-time wind conditions, spot forecasts, gear advice, and daily morning briefings for your favorite spots right at your fingertips.',
    features: [
      'Spot forecasts focused on the water — never inland averages',
      'Live wind speeds, gusts, and hourly forecasts',
      'Gear size recommendations tailored to your weight and quiver',
      'Scheduled morning briefings for all your favorite breaks'
    ],
    accessNote: 'Try 10 instant questions before approval — no sign-up or waitlist required. Continued access after approval is completely free.',
    cta: 'Chat with Windsports',
    link: 'https://t.me/windsavant_bot',
    handle: '@windsavant_bot',
    micrositeUrl: '/wind'
  },
  {
    id: 'sierra',
    name: 'Sierra Guide',
    avatar: sierraAvatar,
    icon: SierraIcon,
    badge: 'Telegram Agent',
    tagline: 'Your guide to the high country',
    description:
      'Provide your location for instant elevation-calibrated mountain weather, live radar scans, and trail results. Contact us for WhatsApp-based access compatible with T-Mobile T-Satellite subscriptions when off the cellular grid.',
    features: [
      'Provide your location or trailhead for instant weather & trail results',
      'Elevation-calibrated summit forecasts & live Doppler radar',
      'Off-grid WhatsApp access for T-Mobile T-Satellite subscribers',
      'Mountain pass status, permit lottery dates & bear canister rules'
    ],
    accessNote: 'Try 10 instant questions before approval — no sign-up or waitlist required. Continued access after approval is completely free (contact us for off-grid WhatsApp).',
    cta: 'Chat with Sierra Guide',
    link: 'https://t.me/sierra_weather_bot',
    handle: '@sierra_weather_bot',
    micrositeUrl: '/sierra'
  },
  {
    id: 'movies',
    name: 'Movies & Series',
    avatar: mediaAvatar,
    icon: FilmIcon,
    badge: 'Telegram Agent',
    tagline: 'Your guide across streaming, series, and cinema',
    description:
      'A dedicated entertainment authority and personal cinema concierge that curates your watchlists, uncovers hidden gems, and tracks new releases across streaming platforms and theaters. Search any title to find live streaming availability, showtimes, ratings, and complete cast intel.',
    features: [
      'Tailored movie & TV series recommendations matching your personal taste',
      'Track your Watchlist, Favorites, and Watched history in one place',
      'Where-to-watch search: live streaming availability across major platforms & showtimes',
      'Rich synopses, cast details, runtime, IMDb/TMDb ratings & poster artwork',
      'Weekly trending releases, premiere schedules, and personalized discovery'
    ],
    accessNote: 'Try 10 instant questions before approval — no sign-up or waitlist required. Continued access after approval is completely free.',
    cta: 'Chat with Movies & Series',
    link: 'https://t.me/mediamoviesseries_bot',
    handle: '@mediamoviesseries_bot',
    micrositeUrl: '/media'
  },
  {
    id: 'chess',
    name: 'TiChess',
    avatar: chessAvatar,
    icon: ChessIcon,
    badge: 'Telegram Agent',
    tagline: 'A self-learning grandmaster rival & opening theory coach',
    description:
      'A self-learning grandmaster rival and conversational coach who plays complete club matches directly inside Telegram. Powered by an adaptive ELO-scaled chess engine with deep ECO opening theory, TiChess remembers your repertoire, analyzes pawn structures, renders live visual boards on every turn, and guides your tactical growth.',
    features: [
      'Extended opening theory: deep ECO repertoire prep, master lines & pawn structure strategies',
      'Adaptive learning engine: remembers your favorite openings, playstyle & rating progression',
      'Dynamic ELO sparring: play as White or Black scaled dynamically to your skill tier',
      'Live visual chessboard diagrams on every turn, with instant setup from board photos',
      'Real-time grandmaster coaching: blunder alerts, brilliant moves & top engine lines'
    ],
    accessNote: 'Try 10 instant questions before approval — no sign-up or waitlist required. Continued access after approval is completely free.',
    cta: 'Chat with TiChess',
    link: 'https://t.me/tichess_bot',
    handle: '@tichess_bot',
    micrositeUrl: '/tichess'
  },
  {
    id: 'art',
    name: 'Dionyziuz Art',
    avatar: artAvatar,
    icon: ArtIcon,
    badge: 'In-app studio',
    tagline: 'Your photos, painted by the old masters',
    description:
      'Our flagship creative studio turns any photo into fine art. Using neural style transfer and deep learning, paint your images with the brushwork and palette of legacy masters — or upload and train your own custom styles.',
    features: [
      '13 specialized brushes, from subtle photo brush to full abstraction',
      'Classic legacy master styles: Van Gogh, Kandinsky, Monet and more',
      'Upload and train your own custom artist styles with instant preview',
      'Colorize brush guard and intelligent palette preservation',
      'Batch processing: up to 2 photos per run, 5 concurrent transformations',
      'Gallery-quality high-resolution downloads ready for print or display'
    ],
    cta: 'Open the studio',
    inApp: true
  }
]
